<template>
<v-container  v-resize="onResize">        
    <v-layout row wrap pt-4>
        <v-flex xs12>
            <h1>Federal Election {{ year }}</h1>
        </v-flex>
    </v-layout>
    <v-layout row wrap pt-4>
        <v-flex xs12>
            <h2>{{ state }}</h2>
        </v-flex>
    </v-layout>
    <br/>
    <v-layout>
        <v-flex md9>
            <h2>First preferences</h2>

                <div><router-link :to="{ name: 'SenateResultByCandidate' }">First preferences by candidate</router-link></div>
                <div><router-link :to="{ name: 'SenateResultByGroup'}">First preferences by group</router-link></div>
       
            <br/>
            <h2>Senators elected</h2>
            <div><router-link :to="{ name: 'SenatorsElected' }">Senators elected</router-link></div>
            <br/>            
        </v-flex>
        <v-flex md3>
            <senate-state-statistics :state="state" :year="year"></senate-state-statistics>        
        </v-flex>        
    </v-layout>
    <h2>Quotas</h2>
    <br/>
    <senate-group-quotas :state="state" :year="year"></senate-group-quotas>
    <br/>
    <div v-if="showDivisions">
        <h2>Division and polling place results</h2>
        <br/>
        <loader v-if="loading" /> 
        <v-data-table 
            v-if="!loading"
            :headers="headers"  
            disable-initial-sort       
            :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
            :hide-headers="isMobile"
            :items="divisions">

            <template v-slot:items="props">
                <router-link v-if="isMobile" class="tr" :to="{ name: 'SenateResultByDivision', params: { division: props.item.Name }}">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item pt-2">
                                <h3 class="pb-xs-0">
                                    {{ props.item.Name }}
                                </h3>
                            </div>
                        </div>
                    </td>
                </router-link>
                <router-link v-else class="tr" :to="{ name: 'SenateResultByDivision', params: { division: props.item.Name }}">
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                </router-link>
            </template>
        </v-data-table>
    </div>
    <br/>
</v-container>
</template>
<script>
    import Loader from '@/components/Loader.vue';
    import SenateGroupQuotas from './SenateGroupQuotas.vue';
    import SenateStateStatistics from './SenateStateStatistics';
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        props: ['state', 'year'],
        created() {
            this.initialiseItems();
        },
        mounted() {
            this.onResize();
        },
        components: {
            Loader,
            SenateGroupQuotas,
            SenateStateStatistics
        },
        data() {
            return {
                loading: true,
                isMobile: false,
                divisions: [],
                headers: [{
                    text: 'Division',
                    value: 'Name'
                }]
            }
        },
        computed: {
            showDivisions() {
                return this.year > 2001 && !(!this.loading && this.divisions.length === 0)
            }
        },
        methods: {
            initialiseItems() {
                this.loading = true;
                const url = `Elections/Divisions?state=${this.state}&year=${this.year}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.divisions = response.data;
                        this.loading = false;
                    });
            },
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
        }
    }
</script>

<style scoped>
    a {
        text-decoration: none;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }

</style>